'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d3Request = require('d3-request');

var _parseHostname = require('@ta-interaktiv/parse-hostname');

require('@ta-interaktiv/semantic-ui/semantic/dist/components/card.css');

var _articleCard = require('./articleCard');

var _articleCard2 = _interopRequireDefault(_articleCard);

require('../style/styles.css');

var _sortMode = require('./sortMode');

var _sortMode2 = _interopRequireDefault(_sortMode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Article Teaser component: downloads the teaser information and stores the
 * downloaded data in its state.
 *
 * @version 1.1
 * @example
 * import ArticleTeasers, {sortMode} from
 * '@ta-interaktiv/react-article-teasers';
 *
 * // more code ...
 *
 * class YourComponent extends React.Component {
 *  render() {
 *
 *    return (
 *      <ArticleTeasers
 *        sorting={sortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
 *        articleIds={['16008934', '21426105', '17814575']}/>
 *    )
 *  }
 *}
 *
 * @param props
 * @param {string[]} props.articleIds An array of CD article IDs, as strings.
 * @param {string} [props.numberOfCards=two] How many article teaser
 * should
 * be shown in a row on desktop devices. As a number word. ('one', 'two',
 * 'three', etc.)
 * @param {SortMode} [props.sorting=manual] The sorting mode. Choose from
 * one of the options from {@link sortMode}.
 * @param {string} [props.className] Additional class names for the group div.
 * @param {string} [props.itemClassName] Additional class names for the
 * individual cards.
 * @param {string} [props.additionalClasses=] Additional classes to be
 * passed to the cards element. As defined in the
 * {@link http://semantic-docs.xeophin.com/views/card.html|Card documentation}.
 * Will be phased out eventually, use props.className instead.
 */
var ArticleTeasers = function (_React$Component) {
  _inherits(ArticleTeasers, _React$Component);

  function ArticleTeasers() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ArticleTeasers);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ArticleTeasers.__proto__ || Object.getPrototypeOf(ArticleTeasers)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      downloadedArticles: new Map()
    }, _this.hostdomain = (0, _parseHostname.parseHostname)().publicationDomain, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ArticleTeasers, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Render nothing when there are no articles
      if (this.props.articleIds.length === 0 || this.state.downloadedArticles.length === 0) {
        return null;
      }

      // region Sorting
      var sortedArticleList = [];

      // Push article data into the sorted list, based on the order of the
      // prop articleId list
      this.props.articleIds.map(function (id) {
        var article = _this2.state.downloadedArticles.get(id);
        if (article !== undefined) {
          sortedArticleList.push(article);
        }
      });

      if (sortedArticleList.length <= 0) {
        return null;
      }

      switch (this.props.sorting) {
        case _sortMode2.default.CHRONOLOGICALLY_BY_CREATION_DATE:
          sortedArticleList.sort(function (a, b) {
            return a.first_published_at - b.first_published_at;
          });
          break;

        case _sortMode2.default.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE:
          sortedArticleList.sort(function (a, b) {
            return b.first_published_at - a.first_published_at;
          });
          break;

        case _sortMode2.default.CHRONOLOGICALLY_BY_UPDATE_DATE:
          sortedArticleList.sort(function (a, b) {
            return a.timestamp_updated_at - b.timestamp_updated_at;
          });
          break;

        case _sortMode2.default.REVERSE_CHRONOLOGICALLY_BY_UPDATE_DATE:
          sortedArticleList.sort(function (a, b) {
            return b.timestamp_updated_at - a.timestamp_updated_at;
          });
          break;

        case _sortMode2.default.NONE:
        case _sortMode2.default.MANUAL:
        default:
          break;
      }

      // endregion

      return _react2.default.createElement(
        'div',
        {
          className: 'article-teasers ui stackable ' + this.props.numberOfCards + ' ' + this.props.additionalClasses + ' ' + this.props.className + ' text cards'
        },
        sortedArticleList.map(function (article, index) {
          if (typeof article.title === 'undefined') {
            return false;
          }

          // Prepare author list
          var authorNames = [];
          var authorsString = '';
          article.authors.map(function (author) {
            authorNames.push(author.name);
          });

          // If we have a nice list of authors that is longer than zero
          // elements, join them with a comma.
          if (authorNames.length > 0) {
            authorsString += authorNames.join(', ');
          }

          return _react2.default.createElement(_articleCard2.default, {
            key: article.legacy_id,
            className: _this2.props.itemClassName,
            url: '//www.' + _this2.hostdomain + '/' + article.legacy_id,
            imageSrc: article.picture_medium_url,
            title: article.title,
            authors: authorsString,
            lead: article.lead
          });
        })
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      // Component did just mount. We will assume that so far, no article data
      // has been downloaded and it is safe to download all requested data.
      this.props.articleIds.map(function (id) {
        _this3.downloadNewArticle(id);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this4 = this;

      // Check if any article data has been downloaded before and download new
      // ones
      nextProps.articleIds.map(function (id) {
        if (_this4.state.downloadedArticles.has(id)) {
          // Data has been downloaded before, don't do anything
          return;
        }

        // Download new article data
        _this4.downloadNewArticle(id);
      });
    }

    /**
     * Loads new, previously not downloaded articles.
     * Updates the component state.
     */

  }, {
    key: 'downloadNewArticle',
    value: function downloadNewArticle(articleID) {
      var _this5 = this;

      (0, _d3Request.json)('//mobile2.' + this.hostdomain + '/api/articles/' + articleID, function (error, articleData) {
        if (error) {
          console.group('Article Teasers');
          console.warn('Article with ID ' + articleID + ' could not be loaded. It might not be published yet or is not available on this website.');
          console.groupEnd();
          return;
        }

        _this5.setState(function (previousState) {
          var articleList = previousState.downloadedArticles;
          articleList.set(articleID, articleData.article);
          return {
            downloadedArticles: articleList
          };
        });
      });
    }
  }]);

  return ArticleTeasers;
}(_react2.default.Component);

ArticleTeasers.defaultProps = {
  numberOfCards: 'two',
  additionalClasses: '',
  className: '',
  itemClassName: '',
  sorting: _sortMode2.default.MANUAL
};
exports.default = ArticleTeasers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-article-teasers/dist/articleTeasers.js
// module id = 103
// module chunks = 0